import { CanMatchFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '@fluxonos/features/user/services/auth.service';
import { UserService } from '@fluxonos/features/user/services/user.service';

export const authMatchGuard: CanMatchFn = (route, segments) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const userService = inject(UserService);

  const isLogged = !!authService.token && !!userService.user;

  if (isLogged) {
    return true;
  }

  router.navigate(['/', 'user', 'sign-in']);
  return false;
};
